import axios from 'axios';

// CRM-facing REST wrappers for the lesson reschedule/cancel negotiation
// feature - see LessonDetailModal.jsx/StudentCard.jsx/StudentPlatform.jsx
// for the 3 places these get used (header badge, pending-list, response
// modal). Reschedule and cancel are two separate backend entity families
// (reschedule needs group consensus, cancel never does), kept as separate
// functions here rather than a fake unified shape.

const jsonHeaders = { withCredentials: true, headers: { 'Content-Type': 'application/json' } };

export function getPendingRescheduleRequests(studentId) {
   return axios.get('/api/reschedule-requests', { params: { student: studentId, status: 'pending' }, withCredentials: true });
}
export function getPendingCancelRequests(studentId) {
   return axios.get('/api/cancel-requests', { params: { student: studentId, status: 'PENDING' }, withCredentials: true });
}
export function getRescheduleDetail(id) {
   return axios.get('/api/reschedule-requests/' + id, { withCredentials: true });
}
export function counterOfferReschedule(id, dayPart, message) {
   return axios.post('/api/reschedule-requests/' + id + '/counter-offer', JSON.stringify({ dayPart, message }), jsonHeaders);
}
export function declineReschedule(id, message) {
   return axios.post('/api/reschedule-requests/' + id + '/decline', JSON.stringify({ message }), jsonHeaders);
}
export function approveCancel(id, message) {
   return axios.post('/api/cancel-requests/' + id + '/approve', JSON.stringify({ message }), jsonHeaders);
}
export function declineCancel(id, message) {
   return axios.post('/api/cancel-requests/' + id + '/decline', JSON.stringify({ message }), jsonHeaders);
}
export function getDayParts() {
   return axios.get('/api/day-parts', { withCredentials: true });
}

// Global (cross-student) variants for PendingApprovalsProvider.jsx's
// dashboard-wide panel - no `student`/`lesson` param at all. Cancel already
// supported this with zero backend change (confirmed by reading
// CancelRequestController); reschedule needed a new backend branch for it.
export function getAllPendingRescheduleRequests() {
   return axios.get('/api/reschedule-requests', { params: { status: 'pending' }, withCredentials: true });
}
export function getAllPendingCancelRequests() {
   return axios.get('/api/cancel-requests', { params: { status: 'PENDING' }, withCredentials: true });
}
export function getLessonRescheduleRequests(lessonId) {
   return axios.get('/api/reschedule-requests', { params: { lesson: lessonId }, withCredentials: true });
}
export function getLessonCancelRequests(lessonId) {
   return axios.get('/api/cancel-requests', { params: { lesson: lessonId }, withCredentials: true });
}
